(function () {
  'use strict';

  angular
      .module('tf.retailer.Util')
      .directive('tfcSwitch', tfcSwitch);

  // @ngInject
  function tfcSwitch() {
    return {
      require : 'ngModel',
      templateUrl : 'Util/Switch.tmpl.html',
      scope : {
        ngModel : '='
      },
      link : function ($scope, $el) {
        var $input = $el.find('input');
        // toggle when pressing space
        $el.on('keypress', function (event) {
          if (event.target !== $input[0] &&
              ' ' === String.fromCharCode(event.keyCode)) {
            event.preventDefault();
            $input[0].click();
            $scope.$apply();
          }
        });
      }
    };
  }

})();
